/* ═══════════════════════════════════════════════════════
   SIZE CALCULATOR — DYNAMIC PRODUCT METAFIELDS
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Size data ── */
  var sizeChart = [
    { band: [24.5, 26.5], bust: [30.00, 31.00], size: "30A", fit: "XS" },
    { band: [24.5, 26.5], bust: [31.00, 32.00], size: "30B", fit: "XS" },
    { band: [24.5, 26.5], bust: [32.00, 33.00], size: "30C", fit: "XS" },
    { band: [24.5, 26.5], bust: [32.50, 34.00], size: "30D", fit: "S" },

    { band: [26.5, 28.5], bust: [32.00, 33.00], size: "32A", fit: "S" },
    { band: [26.5, 28.5], bust: [33.00, 34.00], size: "32B", fit: "S" },
    { band: [26.5, 28.5], bust: [34.00, 34.50], size: "32C", fit: "S" },
    { band: [26.5, 28.5], bust: [34.50, 35.50], size: "32D", fit: "M" },

    { band: [28.5, 30.5], bust: [34.50, 35.00], size: "34A", fit: "M" },
    { band: [28.5, 30.5], bust: [35.00, 36.00], size: "34B", fit: "M" },
    { band: [28.5, 30.5], bust: [36.00, 36.50], size: "34C", fit: "M" },
    { band: [28.5, 30.5], bust: [36.50, 37.50], size: "34D", fit: "L" },
    { band: [28.5, 30.5], bust: [37.50, 38.00], size: "34DD", fit: "XL" },

    { band: [30.5, 32.5], bust: [36.00, 37.00], size: "36A", fit: "L" },
    { band: [30.5, 32.5], bust: [37.00, 38.00], size: "36B", fit: "L" },
    { band: [30.5, 32.5], bust: [37.50, 38.50], size: "36C", fit: "L" },
    { band: [30.5, 32.5], bust: [38.50, 39.50], size: "36D", fit: "XL" },
    { band: [30.5, 32.5], bust: [39.50, 40.00], size: "36DD", fit: "2XL" },

    { band: [32.5, 34.5], bust: [38.00, 39.00], size: "38A", fit: "XL" },
    { band: [32.5, 34.5], bust: [39.00, 40.00], size: "38B", fit: "XL" },
    { band: [32.5, 34.5], bust: [39.50, 40.50], size: "38C", fit: "2XL" },
    { band: [32.5, 34.5], bust: [40.50, 41.50], size: "38D", fit: "2XL" },
    { band: [32.5, 34.5], bust: [41.50, 42.00], size: "38DD", fit: "3XL" },

    { band: [34.5, 36.5], bust: [41.00, 41.50], size: "40B", fit: "2XL" },
    { band: [34.5, 36.5], bust: [41.50, 42.50], size: "40C", fit: "3XL" },
    { band: [34.5, 36.5], bust: [42.50, 43.50], size: "40D", fit: "3XL" },
    { band: [34.5, 36.5], bust: [43.50, 44.00], size: "40DD", fit: "4XL" },

    { band: [36.5, 38.5], bust: [43.00, 43.50], size: "42B", fit: "4XL" },
    { band: [36.5, 38.5], bust: [43.50, 44.00], size: "42C", fit: "4XL" },
    { band: [36.5, 38.5], bust: [44.50, 45.50], size: "42D", fit: "" }
  ];

  var bandRanges = [
    { min: 24.5, max: 26.5 },
    { min: 26.5, max: 28.5 },
    { min: 28.5, max: 30.5 },
    { min: 30.5, max: 32.5 },
    { min: 32.5, max: 34.5 },
    { min: 34.5, max: 36.5 },
    { min: 36.5, max: 38.5 }
  ];

  /* ── State ──
     Internally everything is stored in inches.
  ── */
  var S = {
    under: {
      value: 25.5,
      unit: 'in',
      min: 24.5,
      max: 38.5
    },
    over: {
      value: 30.5,
      unit: 'in',
      min: 30.0,
      max: 45.5
    }
  };

  var STEP_IN = 0.5;
  var screens = [
    'scScreenChart',
    'scScreenFitIntro',
    'scScreenUnderbust',
    'scScreenOverbust',
    'scScreenSummary'
  ];

  var scLastSize = '';
  var scLastFit = '';

  /* ── Helpers ── */

  function fmt(n) {
    return Math.round(n * 100) / 100;
  }

  function formatValue(n) {
    return fmt(n)
      .toString()
      .replace(/\.00$/, '')
      .replace(/(\.\d)0$/, '$1');
  }

  function $(id) {
    return document.getElementById(id);
  }

  function cmToIn(cm) {
    return cm / 2.54;
  }

  function inToCm(inches) {
    return inches * 2.54;
  }

  /* ═══════════════════════════════════════════════════════
     RESET
     ═══════════════════════════════════════════════════════ */

  function resetCalculator() {
    S.under.value = 25.5;
    S.under.unit = 'in';

    S.over.value = 30.5;
    S.over.unit = 'in';

    scLastSize = '';
    scLastFit = '';

    var ubInput = $('scUbInput');
    var obInput = $('scObInput');

    if (ubInput) ubInput.value = '25.5';
    if (obInput) obInput.value = '30.5';

    if ($('scUbValMsg')) $('scUbValMsg').textContent = '';
    if ($('scObValMsg')) $('scObValMsg').textContent = '';

    resetPills('under');
    resetPills('over');

    if ($('scUnitSwitch')) {
      $('scUnitSwitch').checked = false;
    }

    scToggleChartImage();

    buildTape('under');
    buildTape('over');

    /* Restart videos */
    [
      'scIntroVideoEl',
      'scUbVideoEl',
      'scObVideoEl'
    ].forEach(function (id) {
      var video = $(id);

      if (video) {
        try {
          video.currentTime = 0;
          video.load();

          var promise = video.play();

          if (promise && promise.catch) {
            promise.catch(function () {});
          }
        } catch (e) {}
      }
    });
  }

  function resetPills(which) {
    var cmPill = $(
      which === 'under'
        ? 'scUbPillCm'
        : 'scObPillCm'
    );

    var inPill = $(
      which === 'under'
        ? 'scUbPillIn'
        : 'scObPillIn'
    );

    if (cmPill) cmPill.classList.remove('active');
    if (inPill) inPill.classList.add('active');

    var input = $(
      which === 'under'
        ? 'scUbInput'
        : 'scObInput'
    );

    if (!input) return;

    var wrap = input.closest('.sc-input-wrap');

    if (!wrap) return;

    var cmLabel = wrap.querySelector('.sc-cm-label');
    var inLabel = wrap.querySelector('.sc-in-label');

    if (cmLabel) cmLabel.style.display = 'none';
    if (inLabel) inLabel.style.display = 'inline';
  }

  /* ═══════════════════════════════════════════════════════
     OPEN / CLOSE
     ═══════════════════════════════════════════════════════ */

  window.openSizeCalculator = function () {
    resetCalculator();

    scGoTo('scScreenChart');

    var backdrop = $('scBackdrop');
    var drawer = $('scDrawer');

    if (backdrop) backdrop.classList.add('open');
    if (drawer) drawer.classList.add('open');

    document.body.style.overflow = 'hidden';

    buildTape('under');
    buildTape('over');
  };

  window.closeSizeCalculator = function () {
    var backdrop = $('scBackdrop');
    var drawer = $('scDrawer');

    if (backdrop) backdrop.classList.remove('open');
    if (drawer) drawer.classList.remove('open');

    document.body.style.overflow = '';
  };

  document.addEventListener('DOMContentLoaded', function () {
    var bd = $('scBackdrop');

    if (bd) {
      bd.addEventListener('click', closeSizeCalculator);
    }

    buildTape('under');
    buildTape('over');

    initTapeScroll('under');
    initTapeScroll('over');
  });

  document.addEventListener('keydown', function (e) {
    if (
      e.key === 'Escape' &&
      $('scDrawer') &&
      $('scDrawer').classList.contains('open')
    ) {
      closeSizeCalculator();
    }
  });

  /* ═══════════════════════════════════════════════════════
     CHART TOGGLE
     ═══════════════════════════════════════════════════════ */

  window.scToggleChartImage = function () {
    var switchEl = $('scUnitSwitch');

    if (!switchEl) return;

    var isInch = !switchEl.checked;

    var inchImage = $('scChartImgInch');
    var cmImage = $('scChartImgCm');

    if (inchImage) {
      inchImage.classList.toggle('sc-hidden', !isInch);
    }

    if (cmImage) {
      cmImage.classList.toggle('sc-hidden', isInch);
    }
  };

  /* ═══════════════════════════════════════════════════════
     NAVIGATION
     ═══════════════════════════════════════════════════════ */

  function reloadVideo(id) {
    var video = $(id);

    if (!video) return;

    try {
      video.currentTime = 0;
      video.load();

      var promise = video.play();

      if (promise && promise.catch) {
        promise.catch(function () {});
      }
    } catch (e) {}
  }

  window.scGoTo = function (id) {
    screens.forEach(function (screenId) {
      var element = $(screenId);

      if (element) {
        element.classList.toggle(
          'sc-hidden',
          screenId !== id
        );
      }
    });

    var entryCta = $('scEntryCta');
    var fitBtns = $('scFitIntroBtns');

    if (entryCta) {
      entryCta.classList.toggle(
        'sc-hidden',
        id !== 'scScreenChart'
      );
    }

    if (fitBtns) {
      fitBtns.classList.toggle(
        'sc-hidden',
        id !== 'scScreenFitIntro'
      );
    }

    if (id === 'scScreenFitIntro') {
      reloadVideo('scIntroVideoEl');
    }

    if (id === 'scScreenUnderbust') {
      reloadVideo('scUbVideoEl');
    }

    if (id === 'scScreenOverbust') {
      reloadVideo('scObVideoEl');
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (id === 'scScreenUnderbust') {
          scrollTapeTo('under');
        }

        if (id === 'scScreenOverbust') {
          scrollTapeTo('over');
        }
      });
    });
  };

  /* ═══════════════════════════════════════════════════════
     INPUT
     ═══════════════════════════════════════════════════════ */

  window.scRestrictInput = function (e) {
    var allowed =
      /^\d$/.test(e.key) ||
      e.key === '.' ||
      e.key === 'Backspace' ||
      e.key === 'Delete' ||
      e.key === 'ArrowLeft' ||
      e.key === 'ArrowRight' ||
      e.key === 'Tab';

    if (!allowed) {
      e.preventDefault();
    }
  };

  window.scValidateInput = function (which) {
    var input = $(
      which === 'under'
        ? 'scUbInput'
        : 'scObInput'
    );

    var msg = $(
      which === 'under'
        ? 'scUbValMsg'
        : 'scObValMsg'
    );

    var state = S[which];

    if (!input || !state) return;

    var raw = input.value
      .replace(/[^0-9.]/g, '');

    if (raw === '') {
      if (msg) msg.textContent = '';
      return;
    }

    var enteredValue = parseFloat(raw);

    if (isNaN(enteredValue)) {
      if (msg) msg.textContent = '';
      return;
    }

    /* Convert CM input to internal inches */
    var inches =
      state.unit === 'cm'
        ? cmToIn(enteredValue)
        : enteredValue;

    if (
      inches < state.min ||
      inches > state.max
    ) {
      var minShown =
        state.unit === 'cm'
          ? formatValue(inToCm(state.min))
          : formatValue(state.min);

      var maxShown =
        state.unit === 'cm'
          ? formatValue(inToCm(state.max))
          : formatValue(state.max);

      if (msg) {
        msg.textContent =
          'Enter ' +
          minShown +
          ' – ' +
          maxShown +
          ' ' +
          state.unit;
      }

      return;
    }

    if (msg) msg.textContent = '';

    /* Snap to 0.5 inch internally */
    state.value =
      Math.round(inches / STEP_IN) * STEP_IN;

    updateDisplay(which);
    scrollTapeTo(which);
  };

  /* ═══════════════════════════════════════════════════════
     TAPE
     ═══════════════════════════════════════════════════════ */

  function buildTape(which) {
    var strip = $(
      which === 'under'
        ? 'scTapeUnder'
        : 'scTapeOver'
    );

    var state = S[which];

    if (!strip || !state) return;

    strip.innerHTML = '';

    for (
      var i = state.min;
      i <= state.max + 0.001;
      i += STEP_IN
    ) {
      var tick = document.createElement('div');

      var isMajor =
        Math.abs(i % 1) < 0.01;

      var isCurrent =
        Math.abs(i - state.value) < 0.01;

      tick.className =
        'sc-tape-tick ' +
        (isMajor ? 'major' : 'minor') +
        (isCurrent ? ' active' : '');

      var label =
        state.unit === 'in'
          ? formatValue(i)
          : formatValue(inToCm(i));

      if (isMajor || isCurrent) {
        var span = document.createElement('span');

        span.className =
          'sc-tape-tick-label';

        span.textContent = label;

        tick.appendChild(span);
      }

      strip.appendChild(tick);
    }

    scrollTapeTo(which);
  }

  function scrollTapeTo(which) {
    var strip = $(
      which === 'under'
        ? 'scTapeUnder'
        : 'scTapeOver'
    );

    if (!strip || !strip.parentElement) return;

    var track = strip.parentElement;
    var state = S[which];

    var firstTick = strip.children[0];

    if (!firstTick) return;

    var tickWidth =
      firstTick.offsetWidth || 32;

    var index =
      Math.round(
        (state.value - state.min) / STEP_IN
      );

    track.scrollLeft =
      index * tickWidth +
      tickWidth / 2 -
      track.clientWidth / 2;
  }

  function updateDisplay(which) {
    var state = S[which];

    var input = $(
      which === 'under'
        ? 'scUbInput'
        : 'scObInput'
    );

    if (!input || !state) return;

    var shown =
      state.unit === 'in'
        ? formatValue(state.value)
        : formatValue(inToCm(state.value));

    input.value = shown;

    var wrap =
      input.closest('.sc-input-wrap');

    if (wrap) {
      var cmLabel =
        wrap.querySelector('.sc-cm-label');

      var inLabel =
        wrap.querySelector('.sc-in-label');

      if (cmLabel) {
        cmLabel.style.display =
          state.unit === 'cm'
            ? 'inline'
            : 'none';
      }

      if (inLabel) {
        inLabel.style.display =
          state.unit === 'in'
            ? 'inline'
            : 'none';
      }

      var msg =
        wrap.querySelector('.sc-val-msg');

      if (msg) msg.textContent = '';
    }

    buildTape(which);
  }

  window.scStep = function (which, direction) {
    var state = S[which];

    if (!state) return;

    state.value =
      Math.min(
        state.max,
        Math.max(
          state.min,
          Math.round(
            (
              state.value +
              direction * STEP_IN
            ) * 10
          ) / 10
        )
      );

    updateDisplay(which);
    scrollTapeTo(which);
  };

  window.scSetUnit = function (which, unit) {
    var state = S[which];

    if (!state) return;

    state.unit = unit;

    var cmPill = $(
      which === 'under'
        ? 'scUbPillCm'
        : 'scObPillCm'
    );

    var inPill = $(
      which === 'under'
        ? 'scUbPillIn'
        : 'scObPillIn'
    );

    if (cmPill) {
      cmPill.classList.toggle(
        'active',
        unit === 'cm'
      );
    }

    if (inPill) {
      inPill.classList.toggle(
        'active',
        unit === 'in'
      );
    }

    updateDisplay(which);
  };

  function initTapeScroll(which) {
    var strip = $(
      which === 'under'
        ? 'scTapeUnder'
        : 'scTapeOver'
    );

    if (!strip || !strip.parentElement) return;

    var track = strip.parentElement;
    var raf;

    track.addEventListener(
      'scroll',
      function () {
        cancelAnimationFrame(raf);

        raf = requestAnimationFrame(
          function () {
            var center =
              track.scrollLeft +
              track.clientWidth / 2;

            var closest = null;
            var minDistance = Infinity;

            Array.prototype.forEach.call(
              strip.children,
              function (tick) {
                var tickCenter =
                  tick.offsetLeft +
                  tick.offsetWidth / 2;

                var distance =
                  Math.abs(
                    center - tickCenter
                  );

                if (
                  distance < minDistance
                ) {
                  minDistance = distance;
                  closest = tick;
                }
              }
            );

            if (
              closest &&
              minDistance < 20
            ) {
              var index =
                Array.prototype.indexOf.call(
                  strip.children,
                  closest
                );

              var state = S[which];

              var newValue =
                Math.round(
                  (
                    state.min +
                    index * STEP_IN
                  ) * 10
                ) / 10;

              if (
                newValue !== state.value
              ) {
                state.value = newValue;

                var shown =
                  state.unit === 'in'
                    ? formatValue(
                        state.value
                      )
                    : formatValue(
                        inToCm(
                          state.value
                        )
                      );

                var input = $(
                  which === 'under'
                    ? 'scUbInput'
                    : 'scObInput'
                );

                if (input) {
                  input.value = shown;
                }

                Array.prototype.forEach.call(
                  strip.querySelectorAll(
                    '.sc-tape-tick'
                  ),
                  function (tick) {
                    tick.classList.remove(
                      'active'
                    );
                  }
                );

                closest.classList.add(
                  'active'
                );
              }
            }
          }
        );
      },
      { passive: true }
    );
  }

  /* ═══════════════════════════════════════════════════════
     SUMMARY / SIZE CALCULATION
     ═══════════════════════════════════════════════════════ */

  window.scShowSummary = function () {
    var under = S.under.value;
    var over = S.over.value;

    var underSummary =
      S.under.unit === 'in'
        ? formatValue(under) + ' in'
        : formatValue(inToCm(under)) + ' cm';

    var overSummary =
      S.over.unit === 'in'
        ? formatValue(over) + ' in'
        : formatValue(inToCm(over)) + ' cm';

    if ($('scSummaryUnder')) {
      $('scSummaryUnder').textContent =
        underSummary;
    }

    if ($('scSummaryOver')) {
      $('scSummaryOver').textContent =
        overSummary;
    }

    var band = bandRanges.find(function (b) {
      return (
        under >= b.min &&
        under <= b.max
      );
    });

    var match = null;

    if (band) {
      match = sizeChart.find(function (row) {
        return (
          row.band[0] === band.min &&
          row.band[1] === band.max &&
          over >= row.bust[0] &&
          over <= row.bust[1]
        );
      }) || null;
    }

    var notAvailable =
      $('scNotAvail');

    if (match) {
      /*
        IMPORTANT:
        scLastSize = actual bra size,
        e.g. 32B / 36D.
      */
      scLastSize = match.size;
      scLastFit = match.fit;

      var result =
        match.size +
        (
          match.fit
            ? ' · ' + match.fit
            : ''
        );

      if ($('scSummaryResult')) {
        $('scSummaryResult').textContent =
          result;
      }

      if (notAvailable) {
        notAvailable.classList.add(
          'sc-hidden'
        );
      }
    } else {
      scLastSize = '';
      scLastFit = '';

      if ($('scSummaryResult')) {
        $('scSummaryResult').textContent =
          '--';
      }

      if (notAvailable) {
        notAvailable.classList.remove(
          'sc-hidden'
        );
      }
    }

    scGoTo('scScreenSummary');
  };

  /* ═══════════════════════════════════════════════════════
     SELECT ACTUAL PRODUCT VARIANT
     ═══════════════════════════════════════════════════════ */

  window.scSelectFit = function () {
    if (!scLastSize) {
      closeSizeCalculator();
      return;
    }

    var targetSize =
      scLastSize
        .trim()
        .toUpperCase();

    var inputs =
      document.querySelectorAll(
        'input.product-option__input:not([id*="recommendations"])'
      );

    var selected = false;

    inputs.forEach(function (input) {
      var value =
        (input.value || '')
          .trim()
          .toUpperCase();

      if (value === targetSize) {
        input.click();

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );

        selected = true;
      }
    });

    if (!selected) {
      console.log(
        '[Size Calculator] No matching product variant found for:',
        targetSize
      );
    }

    closeSizeCalculator();
  };

})();